import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import { ConclusionPage, WaitingMessage } from '../../styles.style'

const Conclusion = ({ status, setStatus, setStep }) => {
	useEffect(() => {
		if (status === 'success') {
			setTimeout(() => {
				setStep(7)
			}, 3000)
		}
	}, [status])

	return (
		<ConclusionPage>
			<WaitingMessage>
				<div className="box-wait">
					{status === 'wait' && (
						<div>
							<FontAwesome
								spin
								name="spinner"
								size="1x"
								className="icon"
							/>
							<p>
								Estamos verificando o seu cadastro, aguarde alguns
								instantes...
							</p>
						</div>
					)}

					{status === 'success' && (
						<div>
							<FontAwesome
								name="check-circle"
								size="2x"
								className="icon green"
							/>
							<p>
								Uhuuul!
								<br />
								Seu cartão foi aprovado!
								<br />
								Agora vamos configurar seu Muvicard...
							</p>
						</div>
					)}

					{status === 'negative' && (
						<div>
							<FontAwesome
								name="exclamation-circle"
								size="2x"
								className="icon yellow"
							/>
							<p>
								O seu pedido foi analisado, mas nesse momento não temos
								como aprová-lo. Isso não significa que você tenha alguma
								restrição de crédito. Estamos testando esta nova forma
								de fazer o Cartão Muvicard e, infelizmente, não
								conseguimos fornecer crédito para todos os interessados
								neste momento. Nada impede você de efetuar uma nova
								tentativa daqui a alguns dias.
							</p>
							<br />
							<p>
								Caso deseje complementar seu pedido de cartão nos envie os documentos abaixo para <a
									title="Fale conosco"
									href="mailto:faleconosco@muviflex.com.br"
									target="_blank">
									faleconosco@muviflex.com.br
								</a>. Faremos uma nova análise e responderemos com a resposta!
							</p>
							<p style={{ maxWidth: 600, textAlign: "left" }}>
								<ul>
									<li>Foto de Documento frente e verso (Identidade ou CNH)</li>
									<li>Comprovante de residência</li>
								</ul>
							</p>
							<br />
							<p>
								Qualquer dúvida, entre em contato conosco enviando um e-mail para <a
									title="Fale conosco"
									href="mailto:faleconosco@muviflex.com.br"
									target="_blank">
									faleconosco@muviflex.com.br
								</a>.
							</p>

							<footer className="footer-wait">
								<a href="/" className="home">
									Voltar para a Página Inicial Muviflex
								</a>
							</footer>
						</div>
					)}

					{status === 'fail' && (
						<div>
							<FontAwesome
								name="unlink"
								size="2x"
								className="icon yellow"
							/>
							<p>
								Ooops...
								<br />
								Parece que estamos com alguns probleminhas técnicos
								<small>Por favor, tente novamente mais tarde</small>
							</p>

							<footer className="footer-wait">
								<a href="/" className="home">
									Voltar para a Página inicial Muviflex
								</a>
							</footer>
						</div>
					)}
				</div>
			</WaitingMessage>
		</ConclusionPage>
	)
}

export default Conclusion
